import React from 'react';
import { SVGComponentProps } from 'modules/core/components/layout/svg/index';

export const ClockSVG: React.FC<SVGComponentProps> = ({ className }: SVGComponentProps) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
    <g transform="translate(0.75 0.75)">
      <path  d="M13,7.444V13l3.333,3.333M23,13A10,10,0,1,1,13,3,10,10,0,0,1,23,13Z" transform="translate(-3 -3)"/>
    </g>
  </svg>
);